// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable_wrap__gqwcY","table":"DataTable_table__kDARA","clickable":"DataTable_clickable__V1lTX","fixed":"DataTable_fixed__tqsRK"};